export default __webpack_public_path__ + "static/media/icon-arrow-down.d3765dfc.svg";